export default () => ({
  errors: {},
  password: {
    current: null,
    password: null,
    confirmed: null
  }
})



// WEBPACK FOOTER //
// ./src/app/dweller/profile/me/components/change-password/resources/data.js